export default "__VITE_ASSET__3d88d969__"